<template>
  <div
    id="pickup"
    class="shop-section col-xs-12"
    v-bind:class="{ active: isActive }"
    @click="$emit('activeSection', 'pickup')"
  >
    <div class="header">
      <i class="fas fa-people-carry section-icon" />

      <h5 class="section-title dark-blue-color">
        Pick Up Settings
        <br />
        <small>Define your store pick-up's settings</small>
      </h5>
    </div>
    <b-col class="option-content col-xs-12" v-if="shopInfo && shopInfo.pickup">
      <b-form class="col-xs-12" @submit="saveDetails">
        <b-form-row>
          <b-col sm="12" md="6">
            <b-form-group>
              <div class="checkbox">
                <label>
                  <input type="checkbox" v-model="shopInfo.pickup.allowASAP" />
                  Allow ASAP pickup
                </label>
              </div>
              <small
                >Users can place orders with "as soon as possible" pick up time,
                allowing orders with up to 2 minutes behind pick up time from
                current time.
              </small>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6">
            <b-form-group>
              <div class="checkbox">
                <label>
                  <input type="checkbox" v-model="shopInfo.pickup.preBooking" />
                  Pre-Booking
                </label>
              </div>
              <small
                >Users can book a pick up for upcoming dates with special
                conditions
              </small>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col sm="12" md="6">
            <b-form-group>
              <label>Pre-Booking Conditions</label>
              <textarea
                class="form-control"
                v-model="shopInfo.pickup.preBookingInstructions"
              ></textarea>
              <small
                >Specify the rules for the pre-booking condition, i.e: user must
                pick up 7th of May of 2020 from our CBD store at 11:00 AM.
              </small>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6">
            <b-form-group>
              <div class="checkbox">
                <label>
                  <input
                    type="checkbox"
                    v-model="shopInfo.pickup.hideNormalPickup"
                  />
                  Hide normal pickup
                </label>
              </div>
              <small
                >Enabling this option will hide the normal pickup option in the
                checkout screen showing pre-booking as the only option
              </small>
            </b-form-group>
            <b-form-group>
              <b-form-group
                v-if="user.roles.includes('admin')"
                label="Display Pickup on:"
                description="This option hide takeaway options and other UI elements for dine in bar orders"
              >
                <b-dropdown
                  block
                  variant="primary"
                  toggle-class="text-capitalize"
                  :text="
                    shopInfo.pickup.displayPlatforms &&
                    shopInfo.pickup.displayPlatforms.length > 0
                      ? shopInfo.pickup.displayPlatforms.join(' - ')
                      : 'Select Platform Options'
                  "
                >
                  <b-dropdown-item
                    :active="
                      shopInfo.pickup.displayPlatforms &&
                      shopInfo.pickup.displayPlatforms.includes('marketplace')
                    "
                    @click.stop.prevent="
                      selectPickupDisplayPlatforms('marketplace')
                    "
                    >On the Go Marketplace</b-dropdown-item
                  >
                  <b-dropdown-item
                    :active="
                      shopInfo.pickup.displayPlatforms &&
                      shopInfo.pickup.displayPlatforms.includes('embed')
                    "
                    @click.stop.prevent="selectPickupDisplayPlatforms('embed')"
                    >Embed Store</b-dropdown-item
                  >
                  <b-dropdown-item
                    :active="
                      shopInfo.pickup.displayPlatforms &&
                      shopInfo.pickup.displayPlatforms.includes('kiosk')
                    "
                    @click.stop.prevent="selectPickupDisplayPlatforms('kiosk')"
                    >Kiosk</b-dropdown-item
                  >
                </b-dropdown>
              </b-form-group>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row> </b-form-row>

        <b-row>
          <b-col sm="12" md="6">
            <b-button
              variant="primary"
              type="submit"
              class="float-right mb-1 ml-2"
              :disabled="loading"
              pill
            >
              <b-spinner v-if="loading" />
              <span v-else>Save</span>
            </b-button>
            <b-button
              :variant="
                shopInfo.pickup.enabled ? 'outline-danger' : 'outline-primary'
              "
              @click="togglePickup"
              class="float-right mb-1"
              :disabled="loading"
              pill
            >
              <b-spinner v-if="loading" />
              <span v-else
                >{{ shopInfo.pickup.enabled ? "Disable" : "Enable" }} Pick
                Up</span
              >
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-col>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "shop-pickup",
  props: ["isActive"],
  data: () => ({
    shopInfo: null,
  }),
  computed: {
    ...mapGetters("shop", ["shop", "loading"]),
    ...mapGetters({ user: "userInfo" }),
  },
  methods: {
    saveDetails(e) {
      e.preventDefault();
      let shopInfo = {
        pickup: this.shopInfo.pickup,
      };
      this.$emit("saveChanges", shopInfo);
    },
    togglePickup(e) {
      this.shopInfo.pickup.enabled = !this.shopInfo.pickup.enabled;
      this.saveDetails(e);
    },
    selectPickupDisplayPlatforms(platform) {
      let platforms = [];
      if (this.shopInfo.pickup.displayPlatforms)
        platforms = this.shopInfo.pickup.displayPlatforms;
      if (platforms.includes(platform))
        platforms = platforms.filter((p) => p !== platform);
      else platforms.push(platform);
      this.shopInfo.pickup.displayPlatforms = platforms;
      this.$forceUpdate();
    },
  },
  mounted() {
    this.shopInfo = JSON.parse(JSON.stringify(this.shop));
  },
  watch: {
    shop(newVal) {
      if (!newVal) return;
      this.shopInfo = {
        ...newVal,
      };
    },
  },
};
</script>

<style scoped></style>
